// Campaign statuses (display labels / translation keys)
const campaignStatusEnum = Object.freeze({
  live: 'CampaignsList_Status_Live',
  past: 'CampaignsList_Status_Past',
  scheduled: 'CampaignsList_Status_Scheduled',
  draft: 'CampaignsList_Status_Draft',
  disabled: 'CampaignsList_Status_Disabled'
})

// Campaign status values as returned by the API (status_type field)
const campaignStatusApiEnum = Object.freeze({
  LIVE: 'Live',
  PAST: 'Past',
  SCHEDULED: 'Scheduled',
  DRAFT: 'Draft',
  DISABLED: 'Disabled'
})

export { campaignStatusEnum, campaignStatusApiEnum }



// WEBPACK FOOTER //
// ./src/modules/campaigns/enum/CampaignStatusEnum.js